export const DRIVERLOAD = 'DRIVERLOAD';
export const SHIPMENT = 'SHIPMENT';

export const DRIVER_LOAD_CARGO = 'DRIVER_LOAD_CARGO';
export const SHIPMENT_CARGO = 'SHIPMENT_CARGO';
